import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from "./redux/actions";

import {Layout, Menu, Icon} from 'antd';

import logo from './images/bulb2.svg';
import HeaderSearch from "./components/HeaderSearch";
import SideMenu from "./components/SideMenu";
import SettingsMenu from "./components/SettingsMenu";

import NationalDetailCard from "./containers/NationalDetailCard";
import NationalAreaCard from "./containers/NationalAreaCard";
import NationalCard from "./containers/NationalCard";
import NationalTimelineCard from "./containers/NationalTimelineCard";
import NationalComboCard from "./containers/NationalComboCard";
import NationalHeatCard from "./containers/NationalHeatCard";

import StateDetailCard from "./containers/StateDetailCard";
import StateComboCard from "./containers/StateComboCard";
import StateTimelineCard from "./containers/StateTimelineCard";
import StateCard from "./containers/StateCard";
import StateHeatCard from "./containers/StateHeatCard";
import StateAreaCard from "./containers/StateAreaCard";

import CountyInfoCard from "./containers/CountyDetailCard";
import CountyAreaCard from "./containers/CountyAreaCard";
import CountyTableCard from "./containers/CountyTableCard";

import InfoCard from "./containers/InfoCard";

import './App.css';

const {Header, Content, Sider} = Layout;

const mql = window.matchMedia(`(max-width: 960px)`);

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      mql: mql,
      mobile: false,
      collapsed: true
    };

    this.mediaQueryChanged = this.mediaQueryChanged.bind(this);
  }

  componentWillMount() {
    mql.addListener(this.mediaQueryChanged);
    this.setState({mql: mql, mobile: mql.matches});
  }

  componentWillUnmount() {
    this.state.mql.removeListener(this.mediaQueryChanged);
  }

  mediaQueryChanged() {
    this.setState({
      mql: mql,
      mobile: this.state.mql.matches,
      collapsed: true
    });
  }

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  onSearch = fips => {
    if (fips > 0 && fips <= 99) {
      this.props.selectState(fips);
      this.props.selectPage('state');
    }
    else if (fips > 99) {
      this.props.selectState(Math.floor(fips / 1000), fips);
      this.props.selectPage('county');
    }
  };

  onPageChange = ({key}) => {
    this.props.selectPage(key);
  };

  onMenuSelection = ({key}) => {
    switch (key) {
      case 'reset':
        return this.props.reset();
      case 'data' :
        return window.open('https://www.cms.gov/Research-Statistics-Data-and-Systems/Statistics-Trends-and-Reports/Medicare-Geographic-Variation/GV_PUF.html', '_blank');
      case 'bnl' :
        return window.open('http://bnlconsulting.com', '_blank');
      default:
        return;
    }
  }

  render() {
    return (
      <Layout className="App" style={{height: '100%'}}>
        <Header style={{padding: 0}}>
          <div className="logo">
            <img src={logo} alt="Logo"/>
            <h1>Population<br/>Health Insights</h1>
          </div>
          {!this.state.mobile &&
          <div className="header-right">
            <SettingsMenu onSelect={this.onMenuSelection.bind(this)}/>
          </div>
          }
          {!this.state.mobile &&
          <div className="header-right">
            <Menu
              theme="dark" mode="horizontal"
              className="nav"
              selectedKeys={[this.props.page]}
              onClick={this.onPageChange.bind(this)}>
              <Menu.Item key="national">National Level</Menu.Item>
              <Menu.Item key="state">State Level</Menu.Item>
              <Menu.Item key="county">County Level</Menu.Item>
              <Menu.Item key="info">Information</Menu.Item>
            </Menu>
          </div>
          }
          {!this.state.mobile &&
          <div className="header-right">
            <HeaderSearch
              placeholder="Search Locations"
              data={this.props.search}
              onSelect={this.onSearch}
            />
          </div>
          }
          {this.state.mobile &&
          <div className="header-right">
            <Icon
              className="trigger"
              type={this.state.collapsed ? 'menu-fold' : 'menu-unfold'}
              onClick={this.toggle}
            />
          </div>
          }
        </Header>
        <Layout className="content">
          <Sider
            width={this.state.mobile ? 340 : 220}
            className={this.state.collapsed ? "collapsed" : ""}>
            <SideMenu
              mobile={this.state.mobile}
              onClick={this.toggle}
            />
          </Sider>
          <Content>
            {this.props.page === "national" && (
              <div>
                <NationalDetailCard hideSelector={this.state.mobile}/>
                <NationalAreaCard/>
                <NationalComboCard/>
                <NationalTimelineCard/>
                <NationalCard/>
                <NationalHeatCard/>
              </div>
            )}
            {this.props.page === "state" && (
              <div>
                <StateDetailCard hideSelector={this.state.mobile}/>
                <StateAreaCard/>
                <StateComboCard/>
                <StateTimelineCard/>
                <StateCard/>
                <StateHeatCard/>
              </div>
            )}
            {this.props.page === "county" && (
              <div>
                <CountyInfoCard hideSelector={this.state.mobile}/>
                <CountyAreaCard/>
                <CountyTableCard/>
              </div>
            )}
            {this.props.page === "info" && (
              <div>
                <InfoCard/>
              </div>
            )}
          </Content>
        </Layout>
      </Layout>
    );
  }
}

function mapStoreToProps(store, props) {
  return {
    states: store.states,
    counties: store.counties,
    search: store.search.list,
    page: store.dimensions.page
  }
}

function mapDispatchToProps(dispatch) {
  const a = bindActionCreators(actions, dispatch);
  return {
    selectState: a.selectState,
    selectCounty: a.selectCounty,
    selectPage: a.selectPage,
    reset: a.reset
  }
}

export default connect(mapStoreToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js